import { useMemo } from "react";
import { HollowDotsSpinner } from "react-epic-spinners";
import { Alert } from "antd";
import { useSelector } from "react-redux";
import { useState } from "react";
import dayjsTZ from "../../../../../utils/dayjs";
import { getRandomColor } from "../Employees/Employees";
import {
  Bar,
  BarChart,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const shortings = {
  "IT & Software Development": { color: "#B0DAFF", shortName: "IT" },
  "Human Resources": { color: "#FFB0B0", shortName: "HR" },
  "Finance & Accounting": { color: "#B0FFB0", shortName: "FA" },
  "Sales Management": { color: "#FFB0FF", shortName: "Sales" },
  "Internal Staff": { color: "#FFB0B0", shortName: "Internal" },
  "Architecture & Engineering": { color: "#B0FFB0", shortName: "A&E" },
  Administration: { color: "#FFB0FF", shortName: "Admin" },
  "Project Monitoring & Coordinating": { color: "#B0DAFF", shortName: "PM&C" },
};
function WagesDepartments() {
  const { clockings } = useSelector((state) => state.clockings);
  const { departments } = useSelector((state) => state.departments);
  const { eligibleEmployeesClockIn } = useSelector(
    (state) => state.employeesList
  );

  const dataSet = useMemo(() => {
    let temp = false;
    if (!!eligibleEmployeesClockIn && !!clockings && !!departments) {
      const monthStart = dayjsTZ().startOf("month").valueOf();
      const filteredClockings = clockings?.filter(
        (c) =>
          !!c?.clockInDate &&
          !!c?.clockOutDate &&
          c?.approved === true &&
          dayjsTZ(c?.clockInDate).startOf("month").valueOf() === monthStart
      );

      const clockingsByEmployee = new Map();
      filteredClockings?.forEach((c) => {
        const id = c?.employeeId;
        if (!id) return;
        const bucket = clockingsByEmployee.get(id);
        if (bucket) bucket.push(c);
        else clockingsByEmployee.set(id, [c]);
      });

      temp = {};
      departments?.forEach((d) => {
        temp[d.departmentId] = {
          departmentName:
            shortings[d?.departmentName]?.shortName || d?.departmentName,
          count: 0,
          color: shortings[d.departmentName]?.color || getRandomColor(),
        };
      });
      eligibleEmployeesClockIn?.forEach((e) => {
        let depId = e?.employeeDepartmentId;
        const empClockings = clockingsByEmployee.get(e?.employeeId) || [];
        empClockings.forEach((c) => {
          if (!!temp[depId]) {
            const dayEarned = c?.totalities?.totalPay || 0;
            temp[depId].count += dayEarned;
          }
        });
      });
    }

    return temp
      ? Object.values(temp)?.map((el) => {
          return { name: el?.departmentName, pagat: el?.count.toFixed(2) };
        })
      : [];
  }, [eligibleEmployeesClockIn, clockings, departments]);

  let colors = [
    "#1da193",
    "#1da193",
    "#FCC94A",
    "#ea3943",
    "#1da193",
    "#1da193",
    "#ea3943",
    "#1da193",
  ];

  return (
    <>
      {!!clockings && !!eligibleEmployeesClockIn ? (
        <div className="clock-in-dashboard-card">
          {1 === 1 ? (
            <div
              style={{
                height: "100%",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <ResponsiveContainer width="98%" height="95%">
                <BarChart
                  data={dataSet}
                  margin={{
                    top: 40,
                    right: 40,
                    left: -10,
                    bottom: 10,
                  }}
                  barSize={20}
                >
                  <XAxis
                    dataKey="name"
                    scale="point"
                    padding={{ left: 50, right: 50 }}
                  />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="pagat" fill="#8884d8" barSize={50}>
                    {dataSet.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={colors[index % 20]} />
                    ))}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingTop: 55,
              }}
            >
              <Alert
                type="info"
                showIcon
                message="Nuk ka te dhena statistikore..."
              />
            </div>
          )}
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <HollowDotsSpinner color="#1da193" size={24} />
        </div>
      )}
    </>
  );
}

export default WagesDepartments;
